import dayjs from '../../../dayjs/dayjs_timezone';

export const getDaysArray = (start, end, countDays='') => {
  const arr = [];
  // We don't want time affects the counting
  // Trello: https://trello.com/c/s4VWHDDL/3781-timeslot-bug
  const startDate = new Date(start);
  const isWeekdays = countDays === 'weekdays'

  startDate.setHours(0, 0, 0, 0);
  for (let dt = startDate; dt <= end; dt.setDate(dt.getDate() + 1)) {
    const date = new Date(dt);
    const skipDate = isWeekdays && [0, 6].includes(date.getDay());
    if (!skipDate) {
      arr.push(date);
    }
  }

  return arr;
};

export const getTypeValue = (type) => {
  switch (type) {
    case 0:
      return 'product';
    case 1:
      return 'variant';
    case 2:
      return 'resource';
    default:
      return 'product';
  }
};

export const getQuantity = (start, finish, rangeCountBasis, countDays='') => {
  if (!start || !finish) {
    return 1;
  }
  const daysCount = getDaysArray(start, finish, countDays).length;
  return daysCount - (rangeCountBasis === 0 ? 1 : 0);
};

/**
 * check if a date array contains `date` inside.
 * @param {Array} blackoutsArr - blackout array
 * @param {Date} date - date to compare
 * @returns {Boolean} true if one of blackoutsArr's elements contains date inside, false if otherwise.
 * */
export const isDateInDateRange = (dateArr, date) => (
  dateArr && dateArr.some(
    (dateElement) => dayjs(date).isBetween(dateElement.start.startOf('day'), dateElement.finish.startOf('day')),
  )
);
